import { useEffect, useState, useCallback } from "react";
import LabelInput from "../../../../../shared/components/labelInput";
import { useForm } from "react-hook-form";
import { fetchLicenceAuth } from "../../../../../shared/services/simpleListItemsService";
import NewDateTimePicker from "../../../../../shared/components/newDateTimePicker";
import RadioGroup from "../../../../../shared/components/RadioGroup";
import SpLicenseMapper from "../mappers/spLicenseMapper";
import QuoteFormWrapper from "../../../../../shared/components/quoteFormWrapper";
import SupportNavigationButtons from "../../../components/support/SupportNavigationButtons";
import { handleSupportNext } from "../../../utils/supportNavUtils";
import { useNavigate } from "react-router-dom";
import FieldStack from "../../../../../shared/components/FieldStack";
import QuoteStepHeading from "../../../../../shared/components/QuoteStepHeading";

const SpLicense = () => {
  const {
    register,
    watch,
    setValue,
    control,
    trigger,
    formState: { errors, isValid },
    handleSubmit,
  } = useForm({
    defaultValues: SpLicenseMapper.get(),
    mode: "onChange",
  });

  const [lic, setlic] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();

  const convertArrayFormat = useCallback((array) => {
    if (!Array.isArray(array)) {
      return [];
    }
    return array.map((item) => ({
      value: item.listItemId,
      label: item.listItemDescription,
    }));
  }, []);

  useEffect(() => {
    setIsLoading(true);
    fetchLicenceAuth()
      .then((uber) => setlic(uber))
      .finally(() => setIsLoading(false));
  }, []);

  const vehicleHireOptions = [
    {
      value: "private_hire",
      label: "Private Hire",
    },
    { value: "public_hire", label: "Public Hire/Hackney carriage" },
  ];

  const onSubmit = (data) => {
    SpLicenseMapper.set(data);
    handleSupportNext(navigate);
  };

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <QuoteFormWrapper>
        <QuoteStepHeading title="Licensing authority" className="tw-mb-6" />
        <FieldStack className="tw-w-full">
        <LabelInput
          id="LicenseAuth"
          label="Which licencing authority do you want to change to?"
          type="select"
          options={convertArrayFormat(lic)}
          control={control}
          placeholder="Select licence authority"
          register={register("LicenseAuth", { required: true })}
          errors={errors.LicenseAuth}
          watch={watch("LicenseAuth")}
          trigger={trigger}
          isSearchable={true}
          isLoading={isLoading}
        />
        <RadioGroup
          name="existingUseContinued"
          mainLabel="Will your vehicle continue to be used as the existing use on your policy?"
          register={register}
          trigger={trigger}
          errors={errors.existingUseContinued}
        />
        {watch("existingUseContinued") === "No" && (
          <LabelInput
            id="hireType"
            label="What is your new use"
            type="select"
            options={vehicleHireOptions}
            control={control}
            errors={errors.hireType}
            placeholder="Select hire type"
            register={register("hireType", {
              required: "Required",
            })}
            watch={watch("hireType")}
            trigger={trigger}
          />
        )}
        <RadioGroup
          name="newTaxiBadge"
          mainLabel="Have you received your new taxi badge?"
          register={register}
          trigger={trigger}
          errors={errors.newTaxiBadge}
        />
        <NewDateTimePicker
          name="licenseEffectiveDateTime"
          label="Effective Date and Time"
          errors={errors.licenseEffectiveDateTime}
          setValue={setValue}
          control={control}
          rules={{ required: "Date is required" }}
          watch={watch}
          defaultValue={watch("licenseEffectiveDateTime")}
          minDate={new Date()}
          trigger={trigger}
        />
        </FieldStack>
      </QuoteFormWrapper>
      <SupportNavigationButtons isValid={isValid} />
    </form>
  );
};

export default SpLicense;
